var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoreIcon = function SvgMoreIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91658 8.49984C9.91658 7.71743 9.28232 7.08317 8.49992 7.08317C7.71752 7.08317 7.08325 7.71743 7.08325 8.49984C7.08325 9.28224 7.71752 9.9165 8.49992 9.9165C9.28232 9.9165 9.91658 9.28224 9.91658 8.49984Z",
    fill: "#7D86A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91658 4.24984C9.91658 3.46743 9.28232 2.83317 8.49992 2.83317C7.71752 2.83317 7.08325 3.46743 7.08325 4.24984C7.08325 5.03224 7.71752 5.6665 8.49992 5.6665C9.28232 5.6665 9.91658 5.03224 9.91658 4.24984Z",
    fill: "#7D86A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91658 12.7498C9.91658 11.9674 9.28232 11.3332 8.49992 11.3332C7.71752 11.3332 7.08325 11.9674 7.08325 12.7498C7.08325 13.5322 7.71752 14.1665 8.49992 14.1665C9.28232 14.1665 9.91658 13.5322 9.91658 12.7498Z",
    fill: "#7D86A9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoreIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MoreIcon.677ae6ba.svg";
export { ForwardRef as ReactComponent };